<template>
  <Transition name="landscape-hint">
    <div
      v-if="show"
      class="landscape-hint d-flex flex-column align-center justify-center text-center"
    >
      <VIcon
        class="landscape-hint__icon mb-4"
        icon="fas fa-mobile-screen"
        size="64"
      />

      <VIcon
        class="landscape-hint__rotate-icon mb-6"
        icon="fas fa-rotate-left"
        size="32"
      />

      <h3 class="text-body-large mb-2">
        {{ t('orientation.title') }}
      </h3>

      <p class="text-body-small mb-8">
        {{ t('orientation.text') }}
      </p>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps({
  show: {
    type: Boolean,
    required: true,
  },
})

const { t } = useI18n()
</script>

<style scoped lang="scss">
.landscape-hint {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.85);
  color: #ffffff;
  padding: 32px;
}

.landscape-hint__icon {
  animation: landscape-hint-bounce 2s ease-in-out infinite;
}

.landscape-hint__rotate-icon {
  animation: landscape-hint-rotate 2s ease-in-out infinite;
}

@keyframes landscape-hint-bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes landscape-hint-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.landscape-hint-enter-active,
.landscape-hint-leave-active {
  transition: opacity 0.3s ease;
}

.landscape-hint-enter-from,
.landscape-hint-leave-to {
  opacity: 0;
}
</style>
